import { Inject, Injectable, forwardRef} from '@angular/core';
import { Response } from '@angular/http';
import { HttpClient } from './http-client.service';

import  { Observable } from 'rxjs/Observable';

import { TrendData } from '../../entities/trend-data';
import { TrendDummyData } from './trend-dummy-data';

import { Settings } from '../../settings';
import { ODataBuilder } from '../../utility/odata/odata-builder';
import { CachedCallService } from './cached-call.service';

@Injectable()
export class TrendDataService {

  private static readonly trendDataBaseUrl:string = `${Settings.apiUrl}/v1/Trends`;

  protected cachedCallService:CachedCallService = new CachedCallService();

  constructor(@Inject(forwardRef(() => HttpClient)) private http:HttpClient) { }

  getTrendData(orgNodeId:string):Promise<TrendData[]>{
    // return this.cachedCallService.invokeSingleCall(
    //   () => {
    //     let oDataBuilder:ODataBuilder = new ODataBuilder(TrendDataService.trendDataBaseUrl);

    //     oDataBuilder
    //       .orderBy("SortOrder");

    //     let trendDataUrl:string = oDataBuilder.toString();
        
    //     return this.http.get(trendDataUrl)
    //         .toPromise()
    //         .then(response => response.json().value);
    //   }
    //   , `getMembershipTrendData_${orgNodeId}`
    // );
    let trendData:TrendData[] = TrendDummyData.trendData1.slice().reverse();

    return Promise.resolve(trendData);
  }
} 



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/services/http/trend-data.service.ts